import ProductDetailExpand from "@scenes/pdp/utils/ProductDetailExpand";
import styled from "styled-components/native";
import { MatchSupplierLocationViewProps } from "./types";
import { Platform } from "react-native";
import { css } from "styled-components/native";
import { matchPairConatinerWidth } from "@scenes/findMatch/utils";
import { useFindMatch } from "@scenes/findMatch/FindMatchContext";

const MatchSupplierLocationView = ({
  itemDetail,
  otherDetail,
  currentIndex,
  productColor,
}: MatchSupplierLocationViewProps) => {
  const { productType, t } = useFindMatch();
  return (
    <PriceDetailContainer>
      <FlexMainView>
        <MainContainerView testID="findMatch.supplierLocation.primary">
          <LeftLabelContainer keyMargin={20}>
            <ProductDetailExpand
              itemDetail={itemDetail}
              isProductDetail={false}
              title={t("productDetailPage.supplierInfo.text")}
              productColor={productColor}
              productType={productType}
            />
          </LeftLabelContainer>
        </MainContainerView>
        <GapView />
        <MainContainerView testID="findMatch.supplierLocation.secondary">
          <LeftLabelContainer keyMargin={20}>
            <ProductDetailExpand
              itemDetail={otherDetail?.[currentIndex]}
              isProductDetail={false}
              title={t("productDetailPage.supplierInfo.text")}
              productColor={productColor}
              productType={productType}
            />
          </LeftLabelContainer>
        </MainContainerView>
      </FlexMainView>
    </PriceDetailContainer>
  );
};

const PriceDetailContainer = styled.View`
  flex-direction: column;
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  ${({ theme }) => matchPairConatinerWidth(theme)}
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
`;

const LeftLabelContainer = styled.View<any>`
  margin: ${({ keyMargin }) => `10px ${keyMargin}px`};
`;

const GapView = styled.View`
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      width: 30px;
    `}
`;

export default MatchSupplierLocationView;
